export interface CasillaValor {
    casilla: string;
    tipo: string;
}

export class DFormulario2100Configuracion {  
    
    static CONFIGURACION_CASILLAS_COMPUESTAS_RANGOS_2100: [number[]] = [
        [151, 823]
    ];

    static CONFIGURACION_CASILLAS_2100: Array<CasillaValor> = [
        //number
        { casilla: 'cs_id_149', tipo: 'number' },
        { casilla: 'cs_id_153', tipo: 'number' },
        { casilla: 'cs_id_154', tipo: 'number' },
        { casilla: 'cs_id_155', tipo: 'number' },
        { casilla: 'cs_id_151', tipo: 'number' },
        { casilla: 'cs_id_157', tipo: 'number' },
        { casilla: 'cs_id_158', tipo: 'number' },
        { casilla: 'cs_id_160', tipo: 'number' },
        { casilla: 'cs_id_162', tipo: 'number' },
        { casilla: 'cs_id_163', tipo: 'number' },
        { casilla: 'cs_id_165', tipo: 'number' },
        { casilla: 'cs_id_167', tipo: 'number' },
        { casilla: 'cs_id_169', tipo: 'number' },
        { casilla: 'cs_id_171', tipo: 'number' },
        { casilla: 'cs_id_172', tipo: 'number' },
        { casilla: 'cs_id_173', tipo: 'number' },
        { casilla: 'cs_id_174', tipo: 'number' },
        { casilla: 'cs_id_175', tipo: 'number' },
        { casilla: 'cs_id_148', tipo: 'number' },
        { casilla: 'cs_id_177', tipo: 'number' },
        { casilla: 'cs_id_228', tipo: 'number' },
        { casilla: 'cs_id_229', tipo: 'number' },
        { casilla: 'cs_id_230', tipo: 'number' },
        { casilla: 'cs_id_139', tipo: 'number' },
        { casilla: 'cs_id_140', tipo: 'number' },
        { casilla: 'cs_id_141', tipo: 'number' },
        { casilla: 'cs_id_142', tipo: 'number' },
        { casilla: 'cs_id_143', tipo: 'number' },
        { casilla: 'cs_id_144', tipo: 'number' },
        { casilla: 'cs_id_673', tipo: 'number' },
        { casilla: 'cs_id_232', tipo: 'number' },
        { casilla: 'cs_id_257', tipo: 'number' },
        { casilla: 'cs_id_235', tipo: 'number' },
        { casilla: 'cs_id_236', tipo: 'number' },
        { casilla: 'cs_id_237', tipo: 'number' },
        { casilla: 'cs_id_238', tipo: 'number' },
        { casilla: 'cs_id_239', tipo: 'number' },
        { casilla: 'cs_id_240', tipo: 'number' },
        { casilla: 'cs_id_241', tipo: 'number' },
        { casilla: 'cs_id_242', tipo: 'number' },
        { casilla: 'cs_id_243', tipo: 'number' },
        { casilla: 'cs_id_244', tipo: 'number' },
        { casilla: 'cs_id_245', tipo: 'number' },
        { casilla: 'cs_id_246', tipo: 'number' },
        { casilla: 'cs_id_247', tipo: 'number' },
        { casilla: 'cs_id_248', tipo: 'number' },
        { casilla: 'cs_id_960', tipo: 'number' },
        { casilla: 'cs_id_249', tipo: 'number' },
        { casilla: 'cs_id_250', tipo: 'number' },
        { casilla: 'cs_id_251', tipo: 'number' },
        { casilla: 'cs_id_252', tipo: 'number' },
        { casilla: 'cs_id_253', tipo: 'number' },
        { casilla: 'cs_id_254', tipo: 'number' },
        { casilla: 'cs_id_255', tipo: 'number' },
        { casilla: 'cs_id_267', tipo: 'number' },
        { casilla: 'cs_id_274', tipo: 'number' },
        { casilla: 'cs_id_258', tipo: 'number' },
        { casilla: 'cs_id_259', tipo: 'number' },
        { casilla: 'cs_id_260', tipo: 'number' },
        { casilla: 'cs_id_261', tipo: 'number' },
        { casilla: 'cs_id_264', tipo: 'number' },
        { casilla: 'cs_id_265', tipo: 'number' },
        { casilla: 'cs_id_266', tipo: 'number' },
        { casilla: 'cs_id_473', tipo: 'number' },
        { casilla: 'cs_id_263', tipo: 'number' },
        { casilla: 'cs_id_268', tipo: 'number' },
        { casilla: 'cs_id_270', tipo: 'number' },
        { casilla: 'cs_id_269', tipo: 'number' },
        { casilla: 'cs_id_271', tipo: 'number' },
        { casilla: 'cs_id_272', tipo: 'number' },
        { casilla: 'cs_id_273', tipo: 'number' },
        { casilla: 'cs_id_664', tipo: 'number' },
        { casilla: 'cs_id_672', tipo: 'number' },
        { casilla: 'cs_id_309', tipo: 'number' },
        { casilla: 'cs_id_310', tipo: 'number' },
        { casilla: 'cs_id_311', tipo: 'number' },
        { casilla: 'cs_id_279', tipo: 'number' },
        { casilla: 'cs_id_290', tipo: 'number' },
        { casilla: 'cs_id_282', tipo: 'number' },
        { casilla: 'cs_id_283', tipo: 'number' },
        { casilla: 'cs_id_284', tipo: 'number' },
        { casilla: 'cs_id_285', tipo: 'number' },
        { casilla: 'cs_id_286', tipo: 'number' },
        { casilla: 'cs_id_287', tipo: 'number' },
        { casilla: 'cs_id_288', tipo: 'number' },
        { casilla: 'cs_id_291', tipo: 'number' },
        { casilla: 'cs_id_292', tipo: 'number' },
        { casilla: 'cs_id_293', tipo: 'number' },
        { casilla: 'cs_id_294', tipo: 'number' },
        { casilla: 'cs_id_297', tipo: 'number' },
        { casilla: 'cs_id_298', tipo: 'number' },
        { casilla: 'cs_id_299', tipo: 'number' },
        { casilla: 'cs_id_669', tipo: 'number' },
        { casilla: 'cs_id_296', tipo: 'number' },
        { casilla: 'cs_id_300', tipo: 'number' },
        { casilla: 'cs_id_301', tipo: 'number' },
        { casilla: 'cs_id_306', tipo: 'number' },
        { casilla: 'cs_id_307', tipo: 'number' },
        { casilla: 'cs_id_303', tipo: 'number' },
        { casilla: 'cs_id_304', tipo: 'number' },
        { casilla: 'cs_id_305', tipo: 'number' },
        { casilla: 'cs_id_233', tipo: 'number' },
        { casilla: 'cs_id_308', tipo: 'number' },
        { casilla: 'cs_id_316', tipo: 'number' },
        { casilla: 'cs_id_346', tipo: 'number' },
        { casilla: 'cs_id_317', tipo: 'number' },
        { casilla: 'cs_id_318', tipo: 'number' },
        { casilla: 'cs_id_319', tipo: 'number' },
        { casilla: 'cs_id_320', tipo: 'number' },
        { casilla: 'cs_id_321', tipo: 'number' },
        { casilla: 'cs_id_322', tipo: 'number' },
        { casilla: 'cs_id_323', tipo: 'number' },
        { casilla: 'cs_id_324', tipo: 'number' },
        { casilla: 'cs_id_325', tipo: 'number' },
        { casilla: 'cs_id_326', tipo: 'number' },
        { casilla: 'cs_id_327', tipo: 'number' },
        { casilla: 'cs_id_328', tipo: 'number' },
        { casilla: 'cs_id_331', tipo: 'number' },
        { casilla: 'cs_id_332', tipo: 'number' },
        { casilla: 'cs_id_333', tipo: 'number' },
        { casilla: 'cs_id_347', tipo: 'number' },
        { casilla: 'cs_id_330', tipo: 'number' },
        { casilla: 'cs_id_334', tipo: 'number' },
        { casilla: 'cs_id_335', tipo: 'number' },
        { casilla: 'cs_id_340', tipo: 'number' },
        { casilla: 'cs_id_341', tipo: 'number' },
        { casilla: 'cs_id_337', tipo: 'number' },
        { casilla: 'cs_id_338', tipo: 'number' },
        { casilla: 'cs_id_339', tipo: 'number' },
        { casilla: 'cs_id_343', tipo: 'number' },
        { casilla: 'cs_id_394', tipo: 'number' },
        { casilla: 'cs_id_395', tipo: 'number' },
        { casilla: 'cs_id_396', tipo: 'number' },
        { casilla: 'cs_id_397', tipo: 'number' },
        { casilla: 'cs_id_401', tipo: 'number' },
        { casilla: 'cs_id_399', tipo: 'number' },
        { casilla: 'cs_id_400', tipo: 'number' },
        { casilla: 'cs_id_402', tipo: 'number' },
        { casilla: 'cs_id_403', tipo: 'number' },
        { casilla: 'cs_id_404', tipo: 'number' },
        { casilla: 'cs_id_405', tipo: 'number' },
        { casilla: 'cs_id_406', tipo: 'number' },
        { casilla: 'cs_id_408', tipo: 'number' },
        { casilla: 'cs_id_409', tipo: 'number' },
        { casilla: 'cs_id_410', tipo: 'number' },
        { casilla: 'cs_id_411', tipo: 'number' },
        { casilla: 'cs_id_412', tipo: 'number' },
        { casilla: 'cs_id_413', tipo: 'number' },
        { casilla: 'cs_id_414', tipo: 'number' },
        { casilla: 'cs_id_415', tipo: 'number' },
        { casilla: 'cs_id_419', tipo: 'number' },
        { casilla: 'cs_id_420', tipo: 'number' },
        { casilla: 'cs_id_416', tipo: 'number' },
        { casilla: 'cs_id_417', tipo: 'number' },
        { casilla: 'cs_id_418', tipo: 'number' },
        { casilla: 'cs_id_422', tipo: 'number' },
        { casilla: 'cs_id_424', tipo: 'number' },
        { casilla: 'cs_id_479', tipo: 'number' },
        { casilla: 'cs_id_531', tipo: 'number' },
        { casilla: 'cs_id_482', tipo: 'number' },
        { casilla: 'cs_id_486', tipo: 'number' },
        { casilla: 'cs_id_678', tipo: 'number' },
        { casilla: 'cs_id_483', tipo: 'number' },
        { casilla: 'cs_id_485', tipo: 'number' },
        { casilla: 'cs_id_538', tipo: 'number' },
        { casilla: 'cs_id_679', tipo: 'number' },
        { casilla: 'cs_id_488', tipo: 'number' },
        { casilla: 'cs_id_489', tipo: 'number' },
        { casilla: 'cs_id_663', tipo: 'number' },
        { casilla: 'cs_id_492', tipo: 'number' },
        { casilla: 'cs_id_493', tipo: 'number' },
        { casilla: 'cs_id_495', tipo: 'number' },
        { casilla: 'cs_id_497', tipo: 'number' },
        { casilla: 'cs_id_499', tipo: 'number' },
        { casilla: 'cs_id_501', tipo: 'number' },
        { casilla: 'cs_id_502', tipo: 'number' },
        { casilla: 'cs_id_804', tipo: 'number' },
        { casilla: 'cs_id_714', tipo: 'number' },
        { casilla: 'cs_id_504', tipo: 'number' },
        { casilla: 'cs_id_508', tipo: 'number' },
        { casilla: 'cs_id_509', tipo: 'number' },
        { casilla: 'cs_id_510', tipo: 'number' },
        { casilla: 'cs_id_511', tipo: 'number' },
        { casilla: 'cs_id_512', tipo: 'number' },
        { casilla: 'cs_id_514', tipo: 'number' },
        { casilla: 'cs_id_515', tipo: 'number' },
        { casilla: 'cs_id_516', tipo: 'number' },
        { casilla: 'cs_id_517', tipo: 'number' },
        { casilla: 'cs_id_518', tipo: 'number' },
        { casilla: 'cs_id_519', tipo: 'number' },
        { casilla: 'cs_id_520', tipo: 'number' },
        { casilla: 'cs_id_521', tipo: 'number' },
        { casilla: 'cs_id_522', tipo: 'number' },
        { casilla: 'cs_id_526', tipo: 'number' },
        { casilla: 'cs_id_523', tipo: 'number' },
        { casilla: 'cs_id_524', tipo: 'number' },
        { casilla: 'cs_id_525', tipo: 'number' },
        { casilla: 'cs_id_529', tipo: 'number' },
        { casilla: 'cs_id_545', tipo: 'number' },
        { casilla: 'cs_id_546', tipo: 'number' },
        { casilla: 'cs_id_547', tipo: 'number' },
        { casilla: 'cs_id_548', tipo: 'number' },
        { casilla: 'cs_id_549', tipo: 'number' },
        { casilla: 'cs_id_550', tipo: 'number' },
        { casilla: 'cs_id_551', tipo: 'number' },
        { casilla: 'cs_id_552', tipo: 'number' },
        { casilla: 'cs_id_553', tipo: 'number' },
        { casilla: 'cs_id_715', tipo: 'number' },
        { casilla: 'cs_id_789', tipo: 'number' },
        { casilla: 'cs_id_554', tipo: 'number' },
        { casilla: 'cs_id_718', tipo: 'number' },
        { casilla: 'cs_id_719', tipo: 'number' },
        { casilla: 'cs_id_720', tipo: 'number' },
        { casilla: 'cs_id_721', tipo: 'number' },
        { casilla: 'cs_id_723', tipo: 'number' },
        { casilla: 'cs_id_724', tipo: 'number' },
        { casilla: 'cs_id_725', tipo: 'number' },
        { casilla: 'cs_id_726', tipo: 'number' },
        { casilla: 'cs_id_728', tipo: 'number' },
        { casilla: 'cs_id_729', tipo: 'number' },
        { casilla: 'cs_id_730', tipo: 'number' },
        { casilla: 'cs_id_731', tipo: 'number' },
        { casilla: 'cs_id_734', tipo: 'number' },
        { casilla: 'cs_id_661', tipo: 'number' },
        { casilla: 'cs_id_736', tipo: 'number' },
        { casilla: 'cs_id_735', tipo: 'number' },
        { casilla: 'cs_id_654', tipo: 'number' },
        { casilla: 'cs_id_313', tipo: 'number' },
        { casilla: 'cs_id_738', tipo: 'number' },
        { casilla: 'cs_id_739', tipo: 'number' },
        { casilla: 'cs_id_655', tipo: 'number' },
        { casilla: 'cs_id_740', tipo: 'number' },
        { casilla: 'cs_id_955', tipo: 'number' },
        { casilla: 'cs_id_956', tipo: 'number' },
        { casilla: 'cs_id_957', tipo: 'number' },
        { casilla: 'cs_id_958', tipo: 'number' },
        { casilla: 'cs_id_742', tipo: 'number' },
        { casilla: 'cs_id_743', tipo: 'number' },
        { casilla: 'cs_id_744', tipo: 'number' },
        { casilla: 'cs_id_745', tipo: 'number' },
        { casilla: 'cs_id_747', tipo: 'number' },
        { casilla: 'cs_id_748', tipo: 'number' },
        { casilla: 'cs_id_959', tipo: 'number' },
        { casilla: 'cs_id_954', tipo: 'number' },
        { casilla: 'cs_id_751', tipo: 'number' },
        { casilla: 'cs_id_753', tipo: 'number' },
        { casilla: 'cs_id_752', tipo: 'number' },
        { casilla: 'cs_id_754', tipo: 'number' },
        { casilla: 'cs_id_759', tipo: 'number' },
        { casilla: 'cs_id_755', tipo: 'number' },
        { casilla: 'cs_id_794', tipo: 'number' },
        { casilla: 'cs_id_762', tipo: 'number' },
        { casilla: 'cs_id_758', tipo: 'number' },
        { casilla: 'cs_id_670', tipo: 'number' },
        { casilla: 'cs_id_760', tipo: 'number' },
        { casilla: 'cs_id_795', tipo: 'number' },
        { casilla: 'cs_id_797', tipo: 'number' },
        { casilla: 'cs_id_796', tipo: 'number' },
        { casilla: 'cs_id_763', tipo: 'number' },
        { casilla: 'cs_id_765', tipo: 'number' },
        { casilla: 'cs_id_766', tipo: 'number' },
        { casilla: 'cs_id_792', tipo: 'number' },
        { casilla: 'cs_id_768', tipo: 'number' },
        { casilla: 'cs_id_769', tipo: 'number' },
        { casilla: 'cs_id_791', tipo: 'number' },
        { casilla: 'cs_id_788', tipo: 'number' },
        { casilla: 'cs_id_676', tipo: 'number' },
        { casilla: 'cs_id_787', tipo: 'number' },
        { casilla: 'cs_id_789', tipo: 'number' },
        { casilla: 'cs_id_680', tipo: 'number' },
        { casilla: 'cs_id_682', tipo: 'number' },
        { casilla: 'cs_id_662', tipo: 'number' },
        { casilla: 'cs_id_683', tipo: 'number' },
        { casilla: 'cs_id_686', tipo: 'number' },
        { casilla: 'cs_id_684', tipo: 'number' },
        { casilla: 'cs_id_687', tipo: 'number' },
        { casilla: 'cs_id_772', tipo: 'number' },
        { casilla: 'cs_id_689', tipo: 'number' },
        { casilla: 'cs_id_384', tipo: 'number' },
        { casilla: 'cs_id_690', tipo: 'number' },
        { casilla: 'cs_id_666', tipo: 'number' },
        { casilla: 'cs_id_364', tipo: 'number' },
        { casilla: 'cs_id_692', tipo: 'number' },
        { casilla: 'cs_id_783', tipo: 'number' },
        { casilla: 'cs_id_694', tipo: 'number' },
        { casilla: 'cs_id_695', tipo: 'number' },
        { casilla: 'cs_id_688', tipo: 'number' },
        { casilla: 'cs_id_780', tipo: 'number' },
        { casilla: 'cs_id_781', tipo: 'number' },
        { casilla: 'cs_id_344', tipo: 'number' },
        { casilla: 'cs_id_777', tipo: 'number' },
        { casilla: 'cs_id_778', tipo: 'number' },
        { casilla: 'cs_id_365', tipo: 'number' },
        { casilla: 'cs_id_366', tipo: 'number' },
        { casilla: 'cs_id_367', tipo: 'number' },
        { casilla: 'cs_id_369', tipo: 'number' },
        { casilla: 'cs_id_774', tipo: 'number' },
        { casilla: 'cs_id_775', tipo: 'number' },
        { casilla: 'cs_id_698', tipo: 'number' },
        { casilla: 'cs_id_699', tipo: 'number' },
        { casilla: 'cs_id_700', tipo: 'number' },
        { casilla: 'cs_id_701', tipo: 'number' },
        { casilla: 'cs_id_702', tipo: 'number' },
        { casilla: 'cs_id_703', tipo: 'number' },
        { casilla: 'cs_id_704', tipo: 'number' },
        { casilla: 'cs_id_705', tipo: 'number' },
        { casilla: 'cs_id_706', tipo: 'number' },
        { casilla: 'cs_id_707', tipo: 'number' },
        { casilla: 'cs_id_708', tipo: 'number' },
        { casilla: 'cs_id_709', tipo: 'number' },
        { casilla: 'cs_id_710', tipo: 'number' },
        { casilla: 'cs_id_371', tipo: 'number' },
        { casilla: 'cs_id_675', tipo: 'number' },
        { casilla: 'cs_id_374', tipo: 'number' },
        { casilla: 'cs_id_377', tipo: 'number' },
        { casilla: 'cs_id_379', tipo: 'number' },
        { casilla: 'cs_id_381', tipo: 'number' },
        { casilla: 'cs_id_382', tipo: 'number' },
        { casilla: 'cs_id_383', tipo: 'number' },
        { casilla: 'cs_id_385', tipo: 'number' },
        { casilla: 'cs_id_386', tipo: 'number' },
        { casilla: 'cs_id_961', tipo: 'number' },
        { casilla: 'cs_id_387', tipo: 'number' },
        { casilla: 'cs_id_388', tipo: 'number' },
        { casilla: 'cs_id_389', tipo: 'number' },
        { casilla: 'cs_id_390', tipo: 'number' },
        { casilla: 'cs_id_391', tipo: 'number' },
        { casilla: 'cs_id_392', tipo: 'number' },
        { casilla: 'cs_id_430', tipo: 'number' },
        { casilla: 'cs_id_756', tipo: 'number' },
        { casilla: 'cs_id_431', tipo: 'number' },
        { casilla: 'cs_id_436', tipo: 'number' },
        { casilla: 'cs_id_677', tipo: 'number' },
        { casilla: 'cs_id_437', tipo: 'number' },
        { casilla: 'cs_id_438', tipo: 'number' },
        { casilla: 'cs_id_439', tipo: 'number' },
        { casilla: 'cs_id_440', tipo: 'number' },
        { casilla: 'cs_id_441', tipo: 'number' },
        { casilla: 'cs_id_442', tipo: 'number' },
        { casilla: 'cs_id_443', tipo: 'number' },
        { casilla: 'cs_id_530', tipo: 'number' },
        { casilla: 'cs_id_444', tipo: 'number' },
        { casilla: 'cs_id_375', tipo: 'number' },
        { casilla: 'cs_id_807', tipo: 'number' },
        { casilla: 'cs_id_372', tipo: 'number' },
        { casilla: 'cs_id_809', tipo: 'number' },
        { casilla: 'cs_id_810', tipo: 'number' },

        { casilla: 'cs_id_29', tipo: 'number' },
        { casilla: 'cs_id_30', tipo: 'number' },
        { casilla: 'cs_id_31', tipo: 'number' },
        { casilla: 'cs_id_32', tipo: 'number' },
        { casilla: 'cs_id_33', tipo: 'number' },
        { casilla: 'cs_id_34', tipo: 'number' },
        { casilla: 'cs_id_35', tipo: 'number' },
        { casilla: 'cs_id_36', tipo: 'number' },
        { casilla: 'cs_id_37', tipo: 'number' },
        { casilla: 'cs_id_38', tipo: 'number' },
        { casilla: 'cs_id_39', tipo: 'number' },
        { casilla: 'cs_id_40', tipo: 'number' },
        { casilla: 'cs_id_41', tipo: 'number' },
        { casilla: 'cs_id_42', tipo: 'number' },
        { casilla: 'cs_id_43', tipo: 'number' },
        { casilla: 'cs_id_44', tipo: 'number' },
        { casilla: 'cs_id_45', tipo: 'number' },
        { casilla: 'cs_id_46', tipo: 'number' },
        { casilla: 'cs_id_47', tipo: 'number' },
        { casilla: 'cs_id_48', tipo: 'number' },
        { casilla: 'cs_id_49', tipo: 'number' },
        { casilla: 'cs_id_50', tipo: 'number' },
        { casilla: 'cs_id_51', tipo: 'number' },
        { casilla: 'cs_id_52', tipo: 'number' },
        { casilla: 'cs_id_53', tipo: 'number' },
        { casilla: 'cs_id_54', tipo: 'number' },
        { casilla: 'cs_id_55', tipo: 'number' },
        { casilla: 'cs_id_56', tipo: 'number' },
        { casilla: 'cs_id_57', tipo: 'number' },
        { casilla: 'cs_id_58', tipo: 'number' },
        { casilla: 'cs_id_59', tipo: 'number' },
        { casilla: 'cs_id_60', tipo: 'number' },
        { casilla: 'cs_id_61', tipo: 'number' },
        { casilla: 'cs_id_62', tipo: 'number' },
        { casilla: 'cs_id_63', tipo: 'number' },
        { casilla: 'cs_id_64', tipo: 'number' },
        { casilla: 'cs_id_65', tipo: 'number' },
        { casilla: 'cs_id_66', tipo: 'number' },
        { casilla: 'cs_id_67', tipo: 'number' },
        { casilla: 'cs_id_68', tipo: 'number' },
        { casilla: 'cs_id_69', tipo: 'number' },
        { casilla: 'cs_id_70', tipo: 'number' },
        { casilla: 'cs_id_71', tipo: 'number' },
        { casilla: 'cs_id_72', tipo: 'number' },
        { casilla: 'cs_id_73', tipo: 'number' },
        { casilla: 'cs_id_74', tipo: 'number' },
        { casilla: 'cs_id_75', tipo: 'number' },
        { casilla: 'cs_id_76', tipo: 'number' },
        { casilla: 'cs_id_77', tipo: 'number' },
        { casilla: 'cs_id_78', tipo: 'number' },
        { casilla: 'cs_id_79', tipo: 'number' },
        { casilla: 'cs_id_80', tipo: 'number' },
        { casilla: 'cs_id_81', tipo: 'number' },
        { casilla: 'cs_id_82', tipo: 'number' },
        { casilla: 'cs_id_83', tipo: 'number' },
        { casilla: 'cs_id_84', tipo: 'number' },
        { casilla: 'cs_id_85', tipo: 'number' },
        { casilla: 'cs_id_86', tipo: 'number' },
        { casilla: 'cs_id_87', tipo: 'number' },
        { casilla: 'cs_id_88', tipo: 'number' },
        { casilla: 'cs_id_89', tipo: 'number' },
        { casilla: 'cs_id_90', tipo: 'number' },
        { casilla: 'cs_id_91', tipo: 'number' },
        { casilla: 'cs_id_92', tipo: 'number' },
        { casilla: 'cs_id_93', tipo: 'number' },
        { casilla: 'cs_id_94', tipo: 'number' },
        { casilla: 'cs_id_95', tipo: 'number' },
        { casilla: 'cs_id_96', tipo: 'number' },
        { casilla: 'cs_id_97', tipo: 'number' },
        { casilla: 'cs_id_98', tipo: 'number' },
        { casilla: 'cs_id_99', tipo: 'number' },
        { casilla: 'cs_id_100', tipo: 'number' },
        { casilla: 'cs_id_101', tipo: 'number' },
        { casilla: 'cs_id_102', tipo: 'number' },
        { casilla: 'cs_id_103', tipo: 'number' },
        { casilla: 'cs_id_104', tipo: 'number' },
        { casilla: 'cs_id_105', tipo: 'number' },
        { casilla: 'cs_id_106', tipo: 'number' },
        { casilla: 'cs_id_107', tipo: 'number' },
        { casilla: 'cs_id_108', tipo: 'number' },
        { casilla: 'cs_id_109', tipo: 'number' },
        { casilla: 'cs_id_110', tipo: 'number' },
        { casilla: 'cs_id_111', tipo: 'number' },
        { casilla: 'cs_id_112', tipo: 'number' },
        { casilla: 'cs_id_113', tipo: 'number' },
        { casilla: 'cs_id_114', tipo: 'number' },
        { casilla: 'cs_id_115', tipo: 'number' },
        { casilla: 'cs_id_116', tipo: 'number' },
        { casilla: 'cs_id_117', tipo: 'number' },
        { casilla: 'cs_id_118', tipo: 'number' },
        { casilla: 'cs_id_119', tipo: 'number' },
        { casilla: 'cs_id_120', tipo: 'number' },
        { casilla: 'cs_id_121', tipo: 'number' },
        { casilla: 'cs_id_122', tipo: 'number' },
        { casilla: 'cs_id_123', tipo: 'number' },
        { casilla: 'cs_id_124', tipo: 'number' },
        { casilla: 'cs_id_125', tipo: 'number' },
        { casilla: 'cs_id_126', tipo: 'number' },
        { casilla: 'cs_id_127', tipo: 'number' },
        { casilla: 'cs_id_128', tipo: 'number' },
        { casilla: 'cs_id_129', tipo: 'number' },
        { casilla: 'cs_id_130', tipo: 'number' },
        { casilla: 'cs_id_131', tipo: 'number' },
        { casilla: 'cs_id_132', tipo: 'number' },
        { casilla: 'cs_id_133', tipo: 'number' },
        { casilla: 'cs_id_134', tipo: 'number' },
        { casilla: 'cs_id_135', tipo: 'number' },
        { casilla: 'cs_id_136', tipo: 'number' },
        { casilla: 'cs_id_137', tipo: 'number' },
        { casilla: 'cs_id_138', tipo: 'number' },
        { casilla: 'cs_id_812', tipo: 'number' },
        { casilla: 'cs_id_813', tipo: 'number' },
        { casilla: 'cs_id_814', tipo: 'number' },

        { casilla: 'cs_id_150', tipo: 'null' },
        { casilla: 'cs_id_152', tipo: 'null' },
        { casilla: 'cs_id_156', tipo: 'null' },
        { casilla: 'cs_id_159', tipo: 'null' },
        { casilla: 'cs_id_161', tipo: 'null' },
        { casilla: 'cs_id_164', tipo: 'null' },
        { casilla: 'cs_id_166', tipo: 'null' },
        { casilla: 'cs_id_168', tipo: 'null' },
        { casilla: 'cs_id_170', tipo: 'null' },
        { casilla: 'cs_id_176', tipo: 'null' },
        { casilla: 'cs_id_231', tipo: 'null' },
        { casilla: 'cs_id_234', tipo: 'null' },
        { casilla: 'cs_id_262', tipo: 'null' },
        { casilla: 'cs_id_275', tipo: 'null' },
        { casilla: 'cs_id_278', tipo: 'null' },
        { casilla: 'cs_id_312', tipo: 'null' },
        { casilla: 'cs_id_314', tipo: 'null' },
        { casilla: 'cs_id_315', tipo: 'null' },
        { casilla: 'cs_id_280', tipo: 'null' },
        { casilla: 'cs_id_295', tipo: 'null' },
        { casilla: 'cs_id_345', tipo: 'null' },
        { casilla: 'cs_id_329', tipo: 'null' },
        { casilla: 'cs_id_342', tipo: 'null' },
        { casilla: 'cs_id_393', tipo: 'null' },
        { casilla: 'cs_id_398', tipo: 'null' },
        { casilla: 'cs_id_407', tipo: 'null' },
        { casilla: 'cs_id_421', tipo: 'null' },
        { casilla: 'cs_id_478', tipo: 'null' },
        { casilla: 'cs_id_480', tipo: 'null' },
        { casilla: 'cs_id_481', tipo: 'null' },
        { casilla: 'cs_id_487', tipo: 'null' },
        { casilla: 'cs_id_491', tipo: 'null' },
        { casilla: 'cs_id_494', tipo: 'null' },
        { casilla: 'cs_id_496', tipo: 'null' },
        { casilla: 'cs_id_498', tipo: 'null' },
        { casilla: 'cs_id_500', tipo: 'null' },
        { casilla: 'cs_id_802', tipo: 'null' },
        { casilla: 'cs_id_713', tipo: 'null' },
        { casilla: 'cs_id_667', tipo: 'null' },
        { casilla: 'cs_id_503', tipo: 'null' },
        { casilla: 'cs_id_513', tipo: 'null' },
        { casilla: 'cs_id_528', tipo: 'null' },
        { casilla: 'cs_id_717', tipo: 'null' },
        { casilla: 'cs_id_722', tipo: 'null' },
        { casilla: 'cs_id_727', tipo: 'null' },
        { casilla: 'cs_id_732', tipo: 'null' },
        { casilla: 'cs_id_733', tipo: 'null' },
        { casilla: 'cs_id_737', tipo: 'null' },
        { casilla: 'cs_id_741', tipo: 'null' },
        { casilla: 'cs_id_746', tipo: 'null' },
        { casilla: 'cs_id_750', tipo: 'null' },
        { casilla: 'cs_id_793', tipo: 'null' },
        { casilla: 'cs_id_761', tipo: 'null' },
        { casilla: 'cs_id_757', tipo: 'null' },
        { casilla: 'cs_id_764', tipo: 'null' },
        { casilla: 'cs_id_767', tipo: 'null' },
        { casilla: 'cs_id_786', tipo: 'null' },
        { casilla: 'cs_id_770', tipo: 'null' },
        { casilla: 'cs_id_681', tipo: 'null' },
        { casilla: 'cs_id_685', tipo: 'null' },
        { casilla: 'cs_id_691', tipo: 'null' },
        { casilla: 'cs_id_782', tipo: 'null' },
        { casilla: 'cs_id_693', tipo: 'null' },
        { casilla: 'cs_id_779', tipo: 'null' },
        { casilla: 'cs_id_776', tipo: 'null' },
        { casilla: 'cs_id_696', tipo: 'null' },
        { casilla: 'cs_id_697', tipo: 'null' },
        { casilla: 'cs_id_773', tipo: 'null' },
        { casilla: 'cs_id_370', tipo: 'null' },
        { casilla: 'cs_id_674', tipo: 'null' },
        { casilla: 'cs_id_373', tipo: 'null' },
        { casilla: 'cs_id_376', tipo: 'null' },
        { casilla: 'cs_id_378', tipo: 'null' },
        { casilla: 'cs_id_380', tipo: 'null' },
        { casilla: 'cs_id_432', tipo: 'null' },
        { casilla: 'cs_id_433', tipo: 'null' },
        { casilla: 'cs_id_434', tipo: 'null' },
        { casilla: 'cs_id_671', tipo: 'null' },
        { casilla: 'cs_id_435', tipo: 'null' },
        { casilla: 'cs_id_808', tipo: 'null' },
        { casilla: 'cs_id_811', tipo: 'null' },

        { casilla: 'cs_id_555', tipo: 'obj' },
        { casilla: 'cs_id_559', tipo: 'obj' },
        { casilla: 'cs_id_557', tipo: 'obj' },
        { casilla: 'cs_id_556', tipo: 'obj' },
        { casilla: 'cs_id_562', tipo: 'obj' },
        { casilla: 'cs_id_558', tipo: 'obj' },
        { casilla: 'cs_id_560', tipo: 'obj' },
        { casilla: 'cs_id_561', tipo: 'obj' },
        { casilla: 'cs_id_563', tipo: 'obj' },
        { casilla: 'cs_id_564', tipo: 'obj' },
        { casilla: 'cs_id_636', tipo: 'obj' },
        { casilla: 'cs_id_639', tipo: 'obj' },
        { casilla: 'cs_id_638', tipo: 'obj' },
        { casilla: 'cs_id_637', tipo: 'obj' },
        { casilla: 'cs_id_640', tipo: 'obj' },
        { casilla: 'cs_id_643', tipo: 'obj' },
        { casilla: 'cs_id_641', tipo: 'obj' },
        { casilla: 'cs_id_642', tipo: 'obj' },
        { casilla: 'cs_id_644', tipo: 'obj' },
        { casilla: 'cs_id_646', tipo: 'obj' },
        { casilla: 'cs_id_647', tipo: 'obj' },
        { casilla: 'cs_id_648', tipo: 'number' },
        { casilla: 'cs_id_649', tipo: 'obj' },
        { casilla: 'cs_id_650', tipo: 'obj' },
        { casilla: 'cs_id_651', tipo: 'obj' },
        { casilla: 'cs_id_798', tipo: 'obj' },
        { casilla: 'cs_id_799', tipo: 'obj' },
        { casilla: 'cs_id_800', tipo: 'obj' },
        { casilla: 'cs_id_801', tipo: 'obj' },
        { casilla: 'cs_id_803', tipo: 'obj' },
        { casilla: 'cs_id_805', tipo: 'obj' },
        { casilla: 'cs_id_901', tipo: 'obj' },
        { casilla: 'cs_id_884', tipo: 'obj' },
        { casilla: 'cs_id_879', tipo: 'obj' },
        { casilla: 'cs_id_881', tipo: 'obj' },
        { casilla: 'cs_id_880', tipo: 'obj' },
        { casilla: 'cs_id_882', tipo: 'obj' },
        { casilla: 'cs_id_902', tipo: 'obj' },
        { casilla: 'cs_id_885', tipo: 'obj' },
        { casilla: 'cs_id_883', tipo: 'obj' },
        { casilla: 'cs_id_903', tipo: 'obj' },
        { casilla: 'cs_id_886', tipo: 'obj' },
        { casilla: 'cs_id_887', tipo: 'obj' },
        { casilla: 'cs_id_895', tipo: 'obj' },
        { casilla: 'cs_id_889', tipo: 'obj' },
        { casilla: 'cs_id_888', tipo: 'obj' },
        { casilla: 'cs_id_894', tipo: 'obj' },
        { casilla: 'cs_id_893', tipo: 'obj' },
        { casilla: 'cs_id_890', tipo: 'obj' },
        { casilla: 'cs_id_891', tipo: 'obj' },
        { casilla: 'cs_id_892', tipo: 'obj' },
        { casilla: 'cs_id_900', tipo: 'obj' },
        { casilla: 'cs_id_904', tipo: 'obj' },
        { casilla: 'cs_id_905', tipo: 'obj' },
        { casilla: 'cs_id_906', tipo: 'obj' },
        { casilla: 'cs_id_907', tipo: 'obj' },
        { casilla: 'cs_id_908', tipo: 'obj' },
        { casilla: 'cs_id_909', tipo: 'obj' },
        { casilla: 'cs_id_910', tipo: 'obj' },
        { casilla: 'cs_id_911', tipo: 'obj' },
        { casilla: 'cs_id_912', tipo: 'obj' },
        { casilla: 'cs_id_711', tipo: 'obj' },
        { casilla: 'cs_id_187', tipo: 'obj' },
        { casilla: 'cs_id_178', tipo: 'obj' },
        { casilla: 'cs_id_179', tipo: 'obj' },
        { casilla: 'cs_id_180', tipo: 'obj' },
        { casilla: 'cs_id_186', tipo: 'obj' },
        { casilla: 'cs_id_181', tipo: 'obj' },
        { casilla: 'cs_id_182', tipo: 'obj' },
        { casilla: 'cs_id_714', tipo: 'obj' },
        { casilla: 'cs_id_188', tipo: 'obj' },
        { casilla: 'cs_id_183', tipo: 'obj' },
        { casilla: 'cs_id_185', tipo: 'obj' },
        { casilla: 'cs_id_184', tipo: 'obj' },
        { casilla: 'cs_id_193', tipo: 'obj' },
        { casilla: 'cs_id_712', tipo: 'obj' },
        { casilla: 'cs_id_221', tipo: 'obj' },
        { casilla: 'cs_id_197', tipo: 'obj' },
        { casilla: 'cs_id_189', tipo: 'obj' },
        { casilla: 'cs_id_190', tipo: 'obj' },
        { casilla: 'cs_id_191', tipo: 'obj' },
        { casilla: 'cs_id_192', tipo: 'obj' },
        { casilla: 'cs_id_194', tipo: 'obj' },
     /*    { casilla: 'cs_id_198', tipo: 'obj' }, */
        { casilla: 'cs_id_222', tipo: 'obj' },
        { casilla: 'cs_id_195', tipo: 'obj' },
        { casilla: 'cs_id_196', tipo: 'obj' },
        { casilla: 'cs_id_423', tipo: 'obj' },
        { casilla: 'cs_id_790', tipo: 'obj' },
        { casilla: 'cs_id_199', tipo: 'obj' },
        { casilla: 'cs_id_224', tipo: 'obj' },
        { casilla: 'cs_id_354', tipo: 'obj' },
        { casilla: 'cs_id_353', tipo: 'obj' },
        { casilla: 'cs_id_356', tipo: 'obj' },
        { casilla: 'cs_id_361', tipo: 'obj' },
        { casilla: 'cs_id_357', tipo: 'obj' },
        { casilla: 'cs_id_355', tipo: 'number' },
        { casilla: 'cs_id_359', tipo: 'obj' },
        { casilla: 'cs_id_360', tipo: 'obj' },
        { casilla: 'cs_id_225', tipo: 'obj' },
        { casilla: 'cs_id_362', tipo: 'obj' }

        
        
    ];

}


// WEBPACK FOOTER //
// D:/GITHUB/F210/V18/rec_ng_renta210v18/src/app/configuracion/dformulario2100-configuracion.ts